import Vue from 'vue'
import Vuex from 'vuex'
import Task from '@/lib/Task'
import TargetTask from '@/lib/TargetTask'
import { RootState } from '@/custom'
import Project from '@/lib/Project'
import Request from '@/lib/Request'
import TaskFinishParam from '@/lib/TaskFinishParam'
import TodoLogPageReq from '@/lib/TodoLogPageReq'
import TodoLog from '@/lib/TodoLog'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		taskList: [],
		projectList: [],
		targetTaskList: [],
		projectLoading: false,
		taskLoading: false,
		logLoading: false,
		stateLoading: false,
		todoLogList: [],
		todoLogPageLoading: false,
		todoLogPageloadMore: true,
	} as RootState,
	mutations: {
		fetchTaskList(state) {
			const localTaskList: TargetTask[] = []
			for (const project of state.projectList || []) {
				const taskList = project.taskList || [];
				for (const taskItem of taskList) {
					localTaskList.push(taskItem);
				}
			}
			state.targetTaskList = localTaskList;
			// state.taskList = JSON.parse(localStorage.getItem("task_list") || '[]');
		},
		saveTaskList(state, taskList: Task[]) {
			state.taskList = taskList;
			localStorage.setItem("task_list", JSON.stringify(taskList));
		},

		addTask(state, task: TargetTask) {
			state.projectLoading = true;
			Request.post("/task/create", task).then(() => {
				store.commit("fetchProjectList");
				console.log("hahjaj");
				state.projectLoading = false;
			});
			// store.commit("fetchTaskList");
			// state.taskList.push(task);
			// store.commit("saveTaskList", state.taskList);
		},
		updateTask(state, task: TargetTask) {
			state.projectLoading = true;
			Request.post("/task/update", task).then(() => {
				store.commit("fetchProjectList");
				state.projectLoading = false;
			});
			// console.log("update task",task);
			// store.commit("saveTaskList", state.taskList);
		},

		deleteTask(state, id: string) {
			store.commit("fetchTaskList");
			if (state.taskList === []) {
				throw new Error('empty task list');
			}
			const delTask = state.taskList.find((task: Task) => {
				return task.id === id;
			})
			if (delTask) delTask.status = 0;
			store.commit("saveTaskList", state.taskList);
		},

		finishTask(state, param: TaskFinishParam) {
			state.projectLoading = true;
			Request.post("/task/finish", param).then(() => {
				store.commit("fetchProjectList");
				state.projectLoading = false;
			});
			// store.commit("fetchTaskList");
			// if (state.taskList === []) {
			// 	throw new Error('empty task list');
			// }
			// const task = state.taskList.find((task : Task) => {
			// 	return task.id === id;
			// });
			// if (task) {
			// 	task.status = 2;
			// 	task.finishTime = new Date();
			// }
			// store.commit("saveTaskList", state.taskList);
		},

		fetchProjectList(state) {
			state.projectLoading = true;
			Request.get("/target/list/lastYear").then(res => {
				state.projectList = (res.data as Project[]) || [];
				console.log("state.projectList:", state.projectList);
				store.commit("fetchTaskList");
				state.projectLoading = false;
			});

			// const projects = JSON.parse(localStorage.getItem("project_list") || '[]');
			// state.projectList = projects;
		},

		saveProjectList(state, projects: Project[]) {
			state.projectList = projects;
			// localStorage.setItem("project_list", JSON.stringify(projects));
		},

		modifyProject(state, project: Project) {
			console.log("modifyProject:", project);
			state.projectLoading = true;
			const pid = project.id;
			if (pid) {
				Request.post("/target/update", project).then(() => {
					store.commit("fetchProjectList");
					state.projectLoading = false;
				});
			} else {
				Request.post("/target/create", project).then(() => {
					store.commit("fetchProjectList");
					state.projectLoading = false;
				});
			}

			// store.commit("fetchProjectList");
			// const p = state.projectList.find(i => i.id === project.id);
			// if (p === undefined) {
			// 	state.projectList.push(project);
			// } else {
			// 	p.name = project.name;
			// 	p.color = project.color;
			// }

			// store.commit("saveProjectList", state.projectList);
		},

		deleteProject(state, id: string) {
			state.projectLoading = true;
			Request.post("/target/delete", { id: id }).then(res => {
				state.projectList = (res.data as Project[]) || [];
				store.commit("fetchProjectList");
				state.projectLoading = false;
			});

			// for (const task of state.taskList) {
			// 	if (task.project_id === id) {
			// 		// 0 表示已删除
			// 		task.status = 0;
			// 	}
			// }
			// store.commit("saveTaskList", state.taskList);

			// // 删除project
			// const project = state.projectList.find(i => i.id === id);
			// if (project) project.status = 0;
			// store.commit("saveProjectList", state.projectList);
		},

		fetchTodoLogPage(state, pageReq: TodoLogPageReq) {
			state.todoLogPageLoading = true;
			const param = {
				pageNum: pageReq.current,
				pageSize: pageReq.size,
			}
			Request.post("/todo/log/page", param).then(res => {
				const data = res.data;
				state.todoLogList.push(...(data.records as TodoLog[]) || []);
				state.todoLogPageLoading = false;
				if (pageReq.current >= data.pages) {
					state.todoLogPageloadMore = false;
				}
				console.log("state.todoLogList:", state.todoLogList);
			});

			// const projects = JSON.parse(localStorage.getItem("project_list") || '[]');
			// state.projectList = projects;
		},

	},
	actions: {
	},
	modules: {
	}
})

export default store;